<div>
  <block-ui>
    <div class="px-3 py-5 bg-primary-50">
      <span class="p-2 m-2 font-semibold">{{this.selectedCustomers()?.length}} customers selected</span>
      <form [formGroup]="formGroup!">
        <div class="flex flex-wrap w-full m-4">
          <div class="w-4/12 p-2 m-2 font-semibold">Subject</div>
          <div class="w-8/12 p-2 m-2">
            <input class="p-4 m-2 rounded-md" pInputText formControlName="subject" class="w-full"/>
          </div>
        </div>
 
        <div class="flex flex-wrap w-full">
          <p-editor formControlName="text" [style]="{ height: '320px' }" class="w-full m-2" />
        </div>
      </form>
      <p-button class="p-2 m-2" (click)="sendEmail()" label="Send" icon="pi pi-send"/>
    </div>
  </block-ui>
</div>
